import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import TemplateForm from "./TemplateForm";

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createDeliveryChargeTemplateValidation } from "../../utils/validationSchemas";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import { tw } from "@careinfo/tailwind";
import Modal from "../Reusable/Modal";
import LocalCombobox from "../Reusable/ComboBox";
import MultipleSelectField from "../Reusable/MultipleCountryField";
import { useState } from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import CreateIcon from "../../Icons/CreateIcon";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const EditDeliveryChargeTemplate = (props: any) => {
  const { id } = props;

  const isBranch =
    new URLSearchParams(useLocation().search).get("type") === "branch";

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createDeliveryChargeTemplateValidation),
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        ...data?.data,
      };
    },
  });

  const { handleEdit, isLoading } = props;
  const merchantId = getValues("merchant_id");

  const [isOpen, setIsOpen] = useState(false);
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "user.full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "user.email",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "user.mobile_number",
      cell: NACell,
    },
  ];
  const { data: merchant, refetch } = useGetHook({
    queryKey: ["merchant", `merchant-${merchantId}`],
    url: `${APIS.MERCHANT}${merchantId}/`,
    params: {},
  });
  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["merchant"],
  });
  const handleAssign = async () => {
    const merchantId = getValues("merchant_id");
    if (!merchantId) {
      setError("merchant_id", {
        type: "manual",
        message: "Please select a merchant",
      });
      return;
    }

    const url = `${APIS.MERCHANT}${merchantId}/`;
    const formData = {
      delivery_charge_template: id,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });

      if (res?.status === 200) {
        refetch();
        setIsOpen(false);
      }
    } catch (err: any) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <TemplateForm
          errors={errors}
          register={register}
          watch={watch}
          setValue={setValue}
          getValues={getValues}
          control={control}
          clearErrors={clearErrors}
        />
      </FormLayout>
      {!isBranch && (
        <>
          <div>
            <div className={tw`text-xl font-bold mb-2 mt-6 text-primary `}>
              Assigned Merchants
            </div>
          </div>
          <div>
            <DataTable
              url={APIS.MERCHANT}
              queryKey={"merchant"}
              columns={defaultColumns}
              tableName={"merchant-list"}
              params={{ delivery_charge_template: id }}
              actionMenu={
                <div
                  className={tw`flex items-center justify-end w-fit border bg-gray-200 cursor-pointer px-2 py-1 rounded-md hover:bg-gray-100`}
                  onClick={() => setIsOpen(true)}
                >
                  <div className={tw`w-30 text-primary`}>Assign Merchant</div>
                </div>
              }
            />
            <Modal
              isOpen={isOpen}
              setIsOpen={() => setIsOpen(false)}
              title={"Assign Merchant"}
            >
              <div
                className={tw`grid grid-cols-1 md:grid-cols-4 gap-3 items-end`}
              >
                <div className={tw`md:col-span-3`}>
                  <ComboboxInput
                    name="merchant_id"
                    placeholder={"Search merchants"}
                    url={APIS.MERCHANT}
                    queryKey={"merchants"}
                    errors={errors?.merchant_id}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                  />
                </div>
                <button
                  type="button"
                  onClick={handleAssign}
                  className={tw`h-10 flex items-center justify-center gap-2 rounded-md bg-primary text-white px-4`}
                >
                  <CreateIcon color="white" />
                  Assign
                </button>
              </div>
            </Modal>
          </div>
        </>
      )}
    </>
  );
};

export default EditDeliveryChargeTemplate;
